// A line amount is one of: a number (9405), an arithmetic formula string
// starting with "=" ("=195*1", shows the makeup in Excel), "" (descriptive
// line, no charge) or any other text such as "TBC" (shown, never summed).

// Only plain arithmetic: numbers, + - * / and brackets. Anything else (cell
// references, functions) is rejected so the PDF and the spreadsheet can never
// disagree about a total.
export function evalFormula(src) {
  const s = String(src).replace(/^=/, "").replace(/\s+/g, "");
  let i = 0;
  const fail = () => { throw new Error(`Can't read "${src}": use numbers and + - * / only`); };
  const num = () => {
    const m = /^\d+(\.\d+)?|^\.\d+/.exec(s.slice(i));
    if (!m) fail();
    i += m[0].length; return parseFloat(m[0]);
  };
  const factor = () => {
    if (s[i] === "-") { i++; return -factor(); }
    if (s[i] === "+") { i++; return factor(); }
    if (s[i] === "(") { i++; const v = expr(); if (s[i] !== ")") fail(); i++; return v; }
    return num();
  };
  const term = () => {
    let v = factor();
    while (s[i] === "*" || s[i] === "/") { const op = s[i++]; const r = factor(); v = op === "*" ? v * r : v / r; }
    return v;
  };
  const expr = () => {
    let v = term();
    while (s[i] === "+" || s[i] === "-") { const op = s[i++]; const r = term(); v = op === "+" ? v + r : v - r; }
    return v;
  };
  if (!s) fail();
  const v = expr();
  if (i !== s.length || !isFinite(v)) fail();
  return Math.round(v * 100) / 100;
}

// Form text → the config's amount (number | "=formula" | "" | text).
export function parseAmount(raw) {
  if (typeof raw === "number") return raw;
  const t = String(raw ?? "").trim();
  if (t === "") return "";
  if (t.startsWith("=")) return t.replace(/\s+/g, "");
  const n = t.replace(/[$,\s]/g, "");
  if (/^-?\d+(\.\d+)?$/.test(n)) return parseFloat(n);
  return t;
}

// What an amount contributes to the subtotal, or null when it is not summed.
export function amountValue(amount) {
  if (typeof amount === "number") return amount;
  if (typeof amount === "string" && amount.startsWith("=")) return evalFormula(amount);
  return null;
}

export function amountError(amount) {
  if (typeof amount === "string" && amount.startsWith("=")) {
    try { evalFormula(amount); } catch (e) { return e.message; }
  }
  return null;
}

export function subtotal(lineItems) {
  const t = (lineItems || []).reduce((sum, li) => sum + (amountValue(li.amount) ?? 0), 0);
  return Math.round(t * 100) / 100;
}

export function fmtUsd(n) {
  const neg = n < 0;
  const s = Math.abs(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${neg ? "-" : ""}$${s}`;
}
